import * as React from 'react';
import Footer from 'app/components/FooterComponent';
import Header from 'app/components/HeaderComponent';
import HeaderImage from 'home/components/HeaderImage';
import Preview from 'home/components/Preview';
import ubuilderBlueLogo from '../../../assets/media/logos/U-Builder_pro_header_logo.png';
import ubuilderWhiteLogo from '../../../assets/media/logos/White_U-Builder_new_logo.png';
import { loadWhatsNew } from 'app/components/WhatsNew/WhatsNewButton';

export default class Home extends React.Component {
  componentDidMount() {
    loadWhatsNew(true);
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    const percent = this.getScrollPercent() / 100;
    const header = document.querySelector<HTMLElement>('.header');
    const headerLogo = document.querySelector<HTMLElement>('.ubuilder-header-logo');
    const logo = document.querySelector<HTMLImageElement>('.ubuilder-logo-at-header');

    if (header) {
      header.style.background = `rgba(10, 60, 93, ${percent})`;
    }

    if (headerLogo) {
      headerLogo.style.background = `rgba(255, 255, 255, ${percent})`;
    }

    if (logo) {
      logo.src = percent > 0.07 ? ubuilderBlueLogo : ubuilderWhiteLogo;
    }
  }

  getScrollPercent() {
    const h = document.documentElement;
    const b = document.body;
    const st = 'scrollTop';
    const sh = 'scrollHeight';
    return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
  }

  goToContent = () => {
    const headerImage = document.querySelector<HTMLElement>('.header-image');

    if (headerImage) {
      window.scrollTo({ top: headerImage.offsetTop + headerImage.offsetHeight, behavior: 'smooth' });
    }
  }

  content() {
    return (
      <>
        <img className="logo" alt="Unirac" src={require('assets/media/logos/Unirac_logo_full_color_ white_slogan.png')} />
        <div className="text">
          Solar Design Software. <br />
          Point. Click. Scale.
        </div>

        <button type="button" className="learn-more-button" onClick={this.goToContent}>
          Watch Introduction Video
          <i className="material-icons">arrow_downward</i>
        </button>
      </>
    );
  }

  render() {
    return (
      <div className="app-content home-page">
        <Header isAtHomePage={true}/>
        <HeaderImage content={this.content()} />
        <div className="home-page-content">
          <Preview />
        </div>
        <Footer />
      </div>
    );
  }
}
